module.exports = __webpack_public_path__ + "static/img/zhifubao.66f41075.png";